// Approved DCC client-logo library — processed from the uploaded asset package
// (deduped, master brands only, trimmed and optically normalized).
const c = (slug, name, sector, ext = "webp") => ({ slug, name, sector, src: `/assets/clients/${slug}.${ext}` });

export const CLIENT_LOGOS = [
  c("taj", "Taj Hotels", "Hospitality"),
  c("vivanta", "Vivanta", "Hospitality"),
  c("seleqtions", "Seleqtions", "Hospitality"),
  c("ginger", "Ginger Hotels", "Hospitality"),
  c("gateway", "The Gateway Hotel", "Hospitality"),
  c("sheraton", "Sheraton", "Hospitality"),
  c("marriott", "Marriott", "Hospitality"),
  c("jw-marriott", "JW Marriott", "Hospitality"),
  c("westin", "Westin", "Hospitality"),
  c("w-hotels", "W Hotels", "Hospitality"),
  c("conrad", "Conrad", "Hospitality"),
  c("hilton", "Hilton", "Hospitality"),
  c("doubletree", "DoubleTree by Hilton", "Hospitality"),
  c("hilton-garden-inn", "Hilton Garden Inn", "Hospitality"),
  c("grand-hyatt", "Grand Hyatt", "Hospitality"),
  c("hyatt-place", "Hyatt Place", "Hospitality"),
  c("hyatt-centric", "Hyatt Centric", "Hospitality"),
  c("hyatt-regency", "Hyatt Regency", "Hospitality"),
  c("four-points", "Four Points by Sheraton", "Hospitality"),
  c("fairfield", "Fairfield by Marriott", "Hospitality"),
  c("courtyard", "Courtyard by Marriott", "Hospitality"),
  c("le-meridien", "Le Méridien", "Hospitality"),
  c("renaissance", "Renaissance Hotels", "Hospitality"),
  c("ritz-carlton", "The Ritz-Carlton", "Hospitality"),
  c("novotel", "Novotel", "Hospitality"),
  c("ibis", "ibis", "Hospitality"),
  c("grand-mercure", "Grand Mercure", "Hospitality"),
  c("holiday-inn", "Holiday Inn", "Hospitality"),
  c("holiday-inn-express", "Holiday Inn Express", "Hospitality"),
  c("crowne-plaza", "Crowne Plaza", "Hospitality"),
  c("radisson", "Radisson", "Hospitality"),
  c("country-inn", "Country Inn & Suites", "Hospitality"),
  c("park-hotels", "The Park Hotels", "Hospitality"),
  c("leela", "The Leela", "Hospitality"),
  c("lemon-tree", "Lemon Tree Hotels", "Hospitality"),
  c("royal-orchid", "Royal Orchid Hotels", "Hospitality"),
  c("fortune", "Fortune Hotels", "Hospitality"),
  c("welcomhotel", "Welcomhotel", "Hospitality"),
  c("itc-hotels", "ITC Hotels", "Hospitality"),
  c("ramada", "Ramada by Wyndham", "Hospitality"),
  c("best-western", "Best Western Plus", "Hospitality", "webp"),
  c("hawthorn", "Hawthorn Suites", "Hospitality"),
  c("club-mahindra", "Club Mahindra", "Hospitality"),
  c("sarovar", "Sarovar Hotels", "Hospitality"),
  c("lords", "Lords Hotels", "Hospitality"),
  c("fern", "The Fern Hotels", "Hospitality"),
  c("goldfinch", "Goldfinch Hotels", "Hospitality"),
  c("fazlani", "Fazlani", "Hospitality"),
  c("avasa", "Avasa Hotels", "Hospitality"),
  c("green-park", "Green Park Hotel", "Hospitality"),
  c("oakwood", "Oakwood", "Hospitality"),
  c("aloft", "Aloft", "Hospitality"),
  c("memento", "Mementos", "Hospitality"),
  c("kfc", "KFC", "Food Service"),
  c("irish-house", "The Irish House", "Food Service", "webp"),
  c("bluefox", "Blue Fox", "Food Service"),
  c("redfox", "Red Fox", "Food Service"),
  c("inorbit", "Inorbit Mall", "Retail & Malls"),
  c("phoenix-palassio", "Phoenix Palassio", "Retail & Malls"),
  c("lulu-mall", "LuLu Mall", "Retail & Malls"),
  c("db-mall", "DB Mall", "Retail & Malls"),
  c("ahmedabad-one", "Ahmedabad One", "Retail & Malls"),
  c("oberoi-mall", "Oberoi Mall", "Retail & Malls"),
  c("reliance", "Reliance", "Corporate & Industrial"),
  c("jll", "JLL", "Corporate & Industrial"),
  c("lodha", "Lodha", "Corporate & Industrial"),
  c("abp", "ABP", "Corporate & Industrial", "svg"),
  c("cipla", "Cipla", "Corporate & Industrial", "svg"),
  c("oracle", "Oracle", "Corporate & Industrial"),
  c("sbi", "State Bank of India", "Corporate & Industrial"),
  c("union-bank", "Union Bank of India", "Corporate & Industrial"),
  c("hinduja", "Hinduja", "Corporate & Industrial"),
  c("vedanta", "Vedanta", "Corporate & Industrial"),
  c("nocil", "NOCIL", "Corporate & Industrial"),
  c("crompton", "Crompton Greaves", "Corporate & Industrial"),
  c("hp", "Hindustan Petroleum", "Corporate & Industrial"),
  c("loreal", "L'Oréal", "Corporate & Industrial"),
  c("apollo", "Apollo Hospitals", "Healthcare"),
];

const bySlug = Object.fromEntries(CLIENT_LOGOS.map((l) => [l.slug, l]));

// Homepage logo wall — 18 strongest marks, sector-mixed (3 rows × 6 on desktop,
// 2 per row on mobile). Full library lives on the Clients page.
export const WALL = ["taj", "marriott", "hilton", "hyatt-regency", "itc-hotels", "leela", "jw-marriott", "sheraton", "radisson", "holiday-inn", "novotel", "kfc", "jll", "reliance", "lulu-mall", "inorbit", "apollo", "cipla"].map((s) => bySlug[s]);
